import { useRouter } from 'next/router';
import { useEffect } from 'react';

const useForceReloadOnBackToResources = () => {
  const router = useRouter();

  useEffect(() => {
    const handlePopState = () => {
      if (window.location.pathname.includes('/resources')) {
        router.replace(router.asPath);
        window.location.reload();
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => window.removeEventListener('popstate', handlePopState);
  }, [router]);
};

export default useForceReloadOnBackToResources;
